import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { AccountContext } from "../../providers/accountProvider";
import LoginIcon from "../Welcome/writer-login-art.svg";
import StudioLogo from "../Images/StudioLogo";
import Loader from "../Loader";
import { post, get } from "../../lib/api";
import { checkForGlobalLogin, emailValidation, getLanguages, handlePageLoadEventLog, saveSession } from "../../lib/utils";
import { menuItemObj } from "../PrivatePage";
import Login from './Login'
import { 
  Container, 
  MainDiv,
  LeftDiv,
  RightDiv,
  IconHolder,
  LogoHolder,
  WritersBenefit,
  ContactUsDiv,
  ContactUsButton,
} from './styles'
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import PublicPageBackButtonNavbar from '../PublicPage'

function GlobalLogin({ history, onUpdateUser }) {
  const [view, changeView] = useState("login");
  const [type, setType] = useState("login");
  const [email, setEmail] = useState("");
  const [langPref, updateLangPref] = useState("");
  const [message, setMessage] = useState({"text":"",color:"red"});
  const [tempSessionInfo, setTempSessionInfo] = useState(null);
  const [loader,setLoader]=useState(true);
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const [activationButton, setActivationButton] = useState(false);
  const referrer = params.get("referrer");
  const [languages,updateLanguages] = useState(getLanguages('IN'))
  const isMobile = window.screen.width < 600;
  const page = params.get('view')
  const mail = params.get('email')
  
  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const mail = query.get('email')
    if(mail) setEmail(mail)
  },[])

  const AutoGlobalLogin = (uid, token) => {
    if(uid && token){
      get('/user_api/user.get_creator_details?is_novel=1',{
        headers:{
          'access-token':token,
          'uid': uid,
        }
      }).then(res => {
        const { result } = res;
        if(result.uid){
          const { fullname , image_url, uid } = result
          const sessionInfo ={
            name:fullname,
            token,
            image_url,
            uid,
          }
          saveSession(sessionInfo)
          history.push(menuItemObj.home);
        }else{  // if user exists but not yet have a creator account
          setTempSessionInfo({token, uid})
          changeView('register')
        }
      })
    }
  }

  useEffect(() => {
    const token = params.get('token')
    const uid = params.get('uid')
    if (page === 'register' && mail) { 
      setTempSessionInfo({token, uid})
      changeView('register')
      setLoader(false)
    }
    else if(page === 'login') { // case when we have uid, token, origin and others in params but we want to login with a new id
      changeView('login')
      setLoader(false)
    }
    else { // normal flow
      checkForGlobalLogin().then(result => {
        updateLanguages(getLanguages(result.countryCode))
        if (result.countryCode === 'IN') {
          history.push('/login')
        }
        else{
          setLoader(false);
        }
      }).catch(error=>{
      setLoader(false);
      })
      handlePageLoadEventLog(type === 'login' ? 'email_log_in':'email_sign_up');
      AutoGlobalLogin(uid, token)
    }
  },[])

  useEffect(() => {
    handlePageLoadEventLog(type === 'login' ? 'email_log_in':'email_sign_up');
  },[type])

  
  const onActivationClick = () => {
    post(`/user_api/activation?is_novel=1`, {
      data: { email: email },
    })
      .then((response) => {
        setActivationButton(false);
        setMessage({"text":response.message,"color":"green"});
      })
      .catch((error) => {
        setActivationButton(false);
        setMessage({...message ,"text":error.message,"color":"red"});
      });
  };
  const onLoginSignupClick=(value,resetForm)=>{
     setType(value)
     resetForm();
     setMessage({...message ,"text":""});
     setActivationButton(false);
  }
  return (
    <Container>
       {loader && 
      <Loader></Loader>}
      {!loader &&
      <MainDiv>
        <LeftDiv>
          <IconHolder>
            <img src={LoginIcon} alt=""/>
          </IconHolder>
        </LeftDiv>
        <RightDiv>
          {!isMobile && <LogoHolder>
            <StudioLogo />
          </LogoHolder>}
          {view === "login" && <Login 
            email={email} 
            onLoginSignupClick={onLoginSignupClick} 
            activationButton={activationButton}
            type={type}
            message={message}
            onActivationClick={onActivationClick}
            setActivationButton={setActivationButton}
            setMessage={setMessage}
            setEmail={setEmail}
            changeView={changeView}
            onUpdateUser={onUpdateUser}
            history={history}
            setTempSessionInfo={setTempSessionInfo}
          />}
          {view === "forgetPassword" && 
            <ForgotPassword
              email={email}
              message={message}
              setMessage={setMessage}
              onActivationClick={onActivationClick}
              activationButton={activationButton}
              emailValidation={emailValidation}
              langPref={langPref}
              setActivationButton={setActivationButton}
              setEmail={setEmail}
            />}
          {view === "register" && 
            <Register
              email={email}
              type={type}
              message={message}
              setMessage={setMessage}
              languages={languages}
              referrer={referrer}
              tempSessionInfo={tempSessionInfo}
              history={history}
              easySignup={page === 'register' && mail}
            />}

          {view !== "create-book" && (
            <>
            <ContactUsDiv>
              <span>Need help?</span>
              <ContactUsButton href="mailto:writersupport@pocketfm.com">
                Contact Us
              </ContactUsButton>
            </ContactUsDiv>
            <WritersBenefit>Checkout our writer’s program <Link to="/author-welfare-audioseries">here</Link></WritersBenefit>
          </>
          )}
        </RightDiv>
      </MainDiv>}
    </Container>
  );
}
const GlobalLoginPageWrapper = (props) => (
  <AccountContext.Consumer>
    {({ onUpdateUser, user }) => (
      <PublicPageBackButtonNavbar>
        <GlobalLogin onUpdateUser={onUpdateUser} user={user} {...props} />
      </PublicPageBackButtonNavbar>
    )}
  </AccountContext.Consumer>
);

export default withRouter(GlobalLoginPageWrapper);